import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FileLibrary } from "@/features/files/FileLibrary";
import { fileOpenPath, filterFileEntries, sortFileEntries, type FileEntry } from "@/features/files/file-index";
import { isFileMockEntry } from "@/features/files/file-mock";
import { openFileInEditor } from "@/features/files/file-open";
import { useDisplayedFiles } from "@/features/files/use-file-entries";
import { useFileListParams } from "@/features/files/use-file-list";
import { ExecutionTaskDrawer } from "@/features/tasks/ExecutionTaskDrawer";
import { RecordDrawer } from "@/features/records/RecordDrawer";

export function WorkspaceFilesPage() {
  const navigate = useNavigate();
  const { kind, source, sort, query, planId, patch, selectKind } = useFileListParams();
  const library = useDisplayedFiles();
  const visible = useMemo(
    () => sortFileEntries(filterFileEntries(library, { text: query, kind, source, projectId: planId }), sort),
    [library, query, kind, source, planId, sort],
  );

  const open = (entry: FileEntry) => {
    if (isFileMockEntry(entry)) return;
    if (entry.ownerKind === "document") {
      navigate(fileOpenPath(entry));
      return;
    }
    openFileInEditor(entry);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
      <FileLibrary
        library={library}
        entries={visible}
        scope="workspace"
        kind={kind}
        source={source}
        query={query}
        planId={planId}
        sort={sort}
        onKind={selectKind}
        onSource={(next) => patch({ source: next === "all" ? null : next })}
        onQuery={(next) => patch({ q: next.trim() ? next : null })}
        onPlan={(next) => patch({ plan: next || null })}
        onSort={(next) => patch({ sort: next === "recent" ? null : next })}
        onOpen={open}
      />
      <ExecutionTaskDrawer />
      <RecordDrawer />
    </div>
  );
}
